import { Divider, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { db } from "astrid-firebase";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Form from "../../../../forms/components/Form/Form";
import ImportStatusLabel from "../../../../imports/components/ImportStatus/ImportStatusLabel";
import useImportDropdownMenuOptions from "../../../../imports/hooks/useImportDropdownMenuOptions";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";

export default function ArticleEditImports({ article }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const options = useImportDropdownMenuOptions();

	const [imports, loading, error] = useCollectionData(
		db.collection("imports").where("subject.ref", "==", article.ref).orderBy("created", "desc").limit(1),
	);

	const latestImport = imports?.[0];

	return (
		<>
			<Divider section horizontal>
				{t("imports", "Imports")}
			</Divider>

			<Form.Group widths="equal">
				<Form.Select
					fluid
					name="imports.enabled"
					label={t("enableImports", "Enable imports")}
					options={[
						{ key: false, text: t("no", "No"), value: false },
						{ key: true, text: t("yes", "Yes"), value: true },
					]}
				/>

				<Form.Select
					fluid
					name="imports.autoDelivery"
					label={t("autoDeliver", "Auto deliver")}
					options={[
						{ key: false, text: t("no", "No"), value: false },
						{ key: true, text: t("yes", "Yes"), value: true },
					]}
				/>
			</Form.Group>

			<LoadingContext data={imports} loading={loading} error={error}>
				{latestImport && (
					<div className="ui field">
						<label>{t("latestImport", "Latest import")}</label>
						<Segment
							style={{
								display: "flex",
								alignItems: "center",
								gap: "1em",
								flex: 1,
								cursor: "pointer",
							}}
							onClick={() => navigate(`/admin/imports/${latestImport.id}`)}
						>
							<ImportStatusLabel importt={latestImport} />
							<span>{latestImport.source}</span>
							<span style={{ whiteSpace: "nowrap", color: "rgba(0,0,0,.4)", marginLeft: "auto" }}>
								{latestImport.created?.toDate?.().toLocaleString()}
							</span>
							<div onClick={(e) => e.stopPropagation()}>
								<DropdownMenu options={options(latestImport)} />
							</div>
						</Segment>
					</div>
				)}
			</LoadingContext>
		</>
	);
}
